import { BRAND_CONFIG } from '@@brand'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useMyBonusHistory } from '@entities/Loyalty/api/bonusHistory.gql'

import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

interface ISavingsProps {
  className?: string;
}

export const Savings: React.FC<ISavingsProps> = ({ className }) => {
  const { t: tn } = useTranslation('personal')
  const { operations } = useMyBonusHistory()

  const totalSpent =
    operations
      .filter((item) => item?.type === 'charge')
      .reduce((sum, item) => sum + (item?.amount || 0), 0) || 0

  return (
    <div className={classNames(styles.savings, className)}>
      <span className={styles.savings__text}>{tn('bonus.savings')}</span>
      <div className={styles.savings__wrapper}>
        <span className={styles.savings__count}>
          {formatPrice(totalSpent || 0, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            style: 'decimal',
          })}{' '}
          {BRAND_CONFIG.currency.symbol}
        </span>
        <span className={styles.savings__description}>
          {tn('bonus.card-loyalty')}
        </span>
      </div>
    </div>
  )
}
